// eslint-disable-next-line @nx/workspace/no-restricted-imports-clone -- the DLS kit has no magnifier icon; Search2Icon is a plain currentColor SVG with no style config, so it renders identically under both themes
import { Search2Icon } from '@chakra-ui/icons';
import { Button, ButtonProps } from '@joinrepublic/dls-ui-kit';

export interface ISearchIconButtonProps
  extends Omit<ButtonProps, 'aria-label'> {
  'aria-label'?: string;
  /** Magnifier colour. Override it so the icon stays legible on dark backgrounds. */
  iconColor?: string;
}

export const SearchIconButton = ({
  'aria-label': ariaLabel = 'Search',
  iconColor = 'neutral.fg-tertiary',
  ...props
}: ISearchIconButtonProps) => {
  return (
    <Button
      aria-label={ariaLabel}
      variant="naked"
      boxSize="10"
      p={0}
      {...props}
    >
      <Search2Icon boxSize="18px" color={iconColor} />
    </Button>
  );
};
